export enum AppContexEnum {
  Partners = 'partners',
  Corporate = 'corporate'
}
